import React from 'react'
import { makeStyles } from '@material-ui/core'
import FooterTop from './footer-top/footer-top'
import FooterBottom from './footer-bottom/footer-bottom'

const useStyles = makeStyles((theme) => ({
  footer: {
    flexShrink: 0,
    background: theme.palette.footer.background,
    minWidth: '289px',
    width: '100%',
    padding: theme.spacing(0, 4, 2, 4),
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4),
    },
  },
}))

const Footer = () => {
  const classes = useStyles()
  return (
    <footer className={classes.footer}>
      <FooterTop />
      <FooterBottom />
    </footer>
  )
}

export default Footer
